export default {
      id: "areas-6-usage",
      viewBox: "0 0 25 25",
      url: "/" + "assets/sprite.svg#areas-6",
      toString: function () {
        return this.url;
      }
    }